import styled, { css } from "styled-components"

import { UITypes } from "types"

import { Spinner } from "components/common/Spinner"

import WidgetHeader from "./WidgetHeader"

const SpinnerContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const ContentWrapper = styled.div<{ isFetching: boolean }>`
  ${({ isFetching }) =>
    isFetching &&
    css`
      opacity: 0.5;
      cursor: default;
    `}
`

const Container = styled.div`
  border-radius: 20px;
  border: 1px solid var(--border-default);
  background: var(--surface-1);
  padding: 0 32px 20px;
  flex: 1 0 420px;
  min-height: 173px;
  position: relative;

  @media only screen and (max-width: 900px) {
    flex: 1 0 60%;
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`

interface WidgetsLayoutProps {
  title: string
  children: React.ReactNode
  className?: string
  buttonText?: string
  onButtonClick?: () => void
  includeCustomRangeSelect?: boolean
  dateSelectOptions?: UITypes.Option[]
  defaultSelectedDateOption?: UITypes.Option
  isFetching?: boolean
  onSelectDateRange?: (date: [string, string]) => void
  minDate?: string
}

const WidgetsLayout = ({
  children,
  title,
  className,
  buttonText,
  onButtonClick,
  includeCustomRangeSelect,
  dateSelectOptions,
  defaultSelectedDateOption,
  isFetching,
  onSelectDateRange,
  minDate,
}: WidgetsLayoutProps) => {
  return (
    <Container className={className}>
      <WidgetHeader
        minDate={minDate}
        title={title}
        buttonText={buttonText}
        onButtonClick={onButtonClick}
        includeCustomRangeSelect={includeCustomRangeSelect}
        onSelectDateRange={onSelectDateRange}
        explicitDateSelectOptions={dateSelectOptions}
        defaultSelectedDateOption={defaultSelectedDateOption}
      />
      <ContentWrapper isFetching={isFetching || false}>{children}</ContentWrapper>
      {isFetching && (
        <SpinnerContainer>
          <Spinner />
        </SpinnerContainer>
      )}
    </Container>
  )
}

export default WidgetsLayout
